"use strict";

exports.__esModule = true;
exports.uppy = exports.plugins = exports.metaFields = exports.locale = exports.cssSize = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@uppy/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// The `uppy` prop receives the Uppy core instance.
var uppy = exports.uppy = _propTypes.default.instanceOf(_core.Uppy);

// A list of plugins to mount inside this component.
var plugins = exports.plugins = _propTypes.default.arrayOf(_propTypes.default.string);

// Language strings for this component.
var locale = exports.locale = _propTypes.default.shape({
  strings: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  pluralize: _propTypes.default.func
});

// List of meta fields for the editor in the Dashboard.
var metaField = _propTypes.default.shape({
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string
});
var metaFields = exports.metaFields = _propTypes.default.oneOfType([_propTypes.default.arrayOf(metaField), _propTypes.default.func]);

// A size in pixels (number) or with some other unit (string).
var cssSize = exports.cssSize = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);